import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Box, SxProps, Typography } from '@mui/material';
import { FC, ReactNode, SyntheticEvent } from 'react';

type VyAccordionProps = {
  title: string;
  icon?: ReactNode;
  children?: ReactNode;
  expanded?: boolean;
  defaultExpanded?: boolean;
  disabled?: boolean;
  onChange?: (event: SyntheticEvent, isExpanded: boolean) => void;
  sx?: SxProps;
};

export const VyAccordion: FC<VyAccordionProps> = ({
  title,
  icon,
  expanded,
  defaultExpanded,
  disabled,
  onChange,
  children,
  sx,
}) => {
  return (
    <Accordion
      expanded={expanded}
      defaultExpanded={defaultExpanded}
      onChange={onChange}
      disabled={disabled}
      square
      sx={{
        boxShadow: 'none',
        borderRadius: 0,
        margin: 0,
        padding: '24px 36px',

        '& .MuiAccordionSummary-root': {
          padding: 0,
          margin: 0,
          height: 'auto',
        },
        '& .MuiAccordionSummary-content': {
          margin: 0,
        },
        '& .MuiAccordionDetails-root': {
          padding: 0,
          marginTop: '22px',
        },
        ...sx,
      }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ fill: '#323232' }} />}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px"
          }}>
          {icon}

          <Typography
            variant="body1"
            sx={{
              fontWeight: 400,
              color: 'text.secondary',
            }}
          >
            {title}
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
};
